



















































import Vue from 'vue'
import ModalDownloadConfirmation from '@/product/components/modal/ModalDownloadConfirmation.vue'

export default Vue.extend({
  components: {
    ModalDownloadConfirmation
  },
  props: {
    supplierResourceLink: {
      type: String,
      required: true
    },
    isUserLogin:{
      type: Boolean,
      required: true
    }
  },
  data():{
    confirmationModalVisible: boolean
  } {
    return {
      confirmationModalVisible: false
    }
  },
  methods: {
    showConfirmationModal() {
      this.confirmationModalVisible = true
    },
    closeConfirmationModal() {
      this.confirmationModalVisible = false
    }
  }
})
